<template>
  <div class="sort-select">
    <button class="sort-select-btn" @click.stop="onOff = !onOff">
      <span class="athena_hidden">{{$t('venue.productList.sort')}}</span>
      <span class="athena_shortSort_mb">{{$t('venue.productList.sort_buy')}}</span> 
      <span class="athena_shortSort">{{$t('venue.productList.sort_buy')}} - {{$t(`${theme && theme=='athena'?'athena':'venue'}.productList.${getSortName()}`)}}</span> 
      <svg class="select-arrow" role="presentation" viewBox="0 0 19 12">
        <polyline
          fill="none"
          stroke="currentColor"
          points="17 2 9.5 10 2 2"
          fill-rule="evenodd"
          stroke-width="2"
          stroke-linecap="square"
        ></polyline>
      </svg>
    </button>
    <div class="PageOverlay" :class="{ showPageOverlay: onOff }"></div>
    <div
      class="select-content"
      :class="{ showSelectContent: onOff }"
      v-show="onOff"
    >
      <div class="mb-close">
        <button>
          <svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">
            <path
              d="M15 0L1 14m14 0L1 0"
              stroke="currentColor"
              fill="none"
              fill-rule="evenodd"
            ></path>
          </svg>
        </button>
        {{$t('venue.productList.sort')}}
      </div>
      <ul class="select-content-list pop-rhombus">
        <li
          v-for="(item, index) in options"
          :key="item.name + index"
          @click="selected = item.value"
          :class="{ actived: selected == item.value }"
        >
          {{ $t(`${theme && theme=='athena'?'athena':'venue'}.productList.${item.name}`) }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["show_star", "api_get_product","theme"],
  data() {
    return {
      selected: this.getSearch("sort") || "manual",
      onOff: false,
      options: [
        {
          name: "featured",
          value: "manual",
        },
        {
          name: "best_selling",
          value: "best-selling",
        },
        {
          name: "low_to_high",
          value: "price-ascending",
        },
        {
          name: "high_to_low",
          value: "price-descending",
        },
        {
          name: "date_new_to_old",
          value: "created-descending",
        },
        {
          name: "date_old_to_new",
          value: "created-ascending",
        },
      ],
    };
  },
  mounted() {
    if (this.show_star) {
      this.options = [
        ...this.options,
        {
          name: "review_high_to_low",
          value: "review-descending",
        },
        {
          name: "rating_high_to_low",
          value: "rating-descending",
        },
      ];
    }
    document.body.addEventListener("click", () => {
      this.onOff = false;
    });
  },
  watch: {
    onOff(newV) {
      if (newV) {
        this.$("body").css({ overflowY: "hidden" });
      } else {
        this.$("body").css({ overflowY: "" });
      }
    },
     selected(newV) {
      if (this.api_get_product) {
        let search = this.replaceSearch("sort", newV, true);
        this.api_get_product(this.formatSearch({search}));
      } else window.open(this.replaceSearch("sort", newV), "_self");
    },
  },
  methods: {
     getSortName() {
      for(let i=0;i<this.options.length;i+=1){
       if(this.options[i].value===this.getSearch('sort')){
           return this.options[i].name
        }
       }
       return 'featured'
     }
  },
};
</script>
<style scoped lang='scss'>
.actived {
  color: #454545 !important;
  font-weight: bold !important;
}
.sort-select {
  display: inline-block;
  position: relative;
  .sort-select-btn {
    display: inline-block;
    cursor: pointer;
    margin: 0;
    background: 0 0;
    border: none;
    border-radius: 0;
    -webkit-appearance: button;
    font-family: Muli-Bold !important;
    letter-spacing: 1px !important;
    font-weight: 400;
    line-height: 23px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    padding: 18px 0;
    padding-left: 45px;
    font-size: 14px;
    color: #333;
    .select-arrow {
      height: 6px;
      margin-left: 2px;
      pointer-events: none;
      display: inline-block;
      fill: currentColor;
      vertical-align: middle;
      stroke-width: 1px;
    }
  }

  .select-content {
    position: absolute;
    box-shadow: 0 -2px 10px rgb(54 54 54 / 20%);
    background-color: white;
    line-height: 1.65;
    z-index: 999;
    right: 0;
    top: 76px;
    .mb-close {
      display: none;
      padding: 13px 20px;
      position: relative;
      font-size: 15px;
      font-family: "Muli-Bold";
      border-bottom: 1px solid rgba(227, 227, 227, 0.4);
      button {
        width: 38px;
        height: 30px;
        position: absolute;
        left: 7px;
        top: 6px;
      }
      svg {
        display: inline-block;
        width: 14px;
        fill: currentColor;
        vertical-align: middle;
        stroke-width: 1px;
        background: 0 0;
        pointer-events: none;
      }
    }
    .select-content-list {
      padding: 18px 0;
      &::after {
        left: unset;
        top: -8px;
        right: 32px;
      }
      li {
        color: #666;
        list-style: none;
        letter-spacing: 1px;
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        display: block;
        padding: 12px 20px;
        white-space: nowrap;
        cursor: pointer;
        user-select: none;
        transition: color 0.2s ease-in-out;
        padding-left: 50px;
        padding-right: 50px;
        text-align: right;
        font-family: Muli;
        text-transform: uppercase;
      }
    }
  }
}
.athena_shortSort_mb,
.athena_shortSort {
  display: none;
}
@media screen and (max-width: 768px) {
  .showPageOverlay {
    opacity: 0.5;
    visibility: visible;
    z-index: 998;
  }
  .sort-select {
    .select-content {
      display: block !important;
      visibility: hidden;
      position: fixed;
      top: unset;
      bottom: 0;
      width: 100%;
      touch-action: manipulation;
      -webkit-transform: translateY(100%);
      transform: translateY(100%);
      -webkit-transition: all 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: all 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
      .mb-close {
        display: block;
      }
      .select-content-list {
        &::after {
          display: none;
        }
        li {
          text-align: center;
        }
      }
    }
    .showSelectContent {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      visibility: visible;
    }
  }
}
</style>